import * as prismic from '@prismicio/client';

export const repositoryName = 'parenthesestalent';
export const apiEndpoint = 'https://parenthesestalent.cdn.prismic.io/api/v2';

export const client = prismic.createClient(repositoryName, {
  accessToken:
    'MC5abDc1VVJJQUFDQUFYOG9i.77-977-977-977-9QEtf77-9Qe-_ve-_ve-_vXPvv73vv71E77-977-977-9Me-_vWxn77-9Rj5g77-9Mn0sTg'
});
